import { Settings as SettingsIcon, Smartphone, Gamepad2 } from "lucide-react";
import { Link, useLocation } from "react-router-dom";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

export function Sidebar() {
  const location = useLocation();
  const isRoot = location.pathname === "/";

  return (
    <aside className="fixed inset-y-0 left-0 z-100 hidden w-14 flex-col border-r bg-background sm:flex">
      <nav className="flex flex-col items-center gap-4 px-2 py-4">
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger asChild>
              <Link
                to="/"
                className={`group flex h-9 w-9 shrink-0 items-center justify-center gap-2 rounded-full text-lg font-semibold md:h-8 md:w-8 md:text-base
                  ${isRoot
                    ? "bg-primary text-primary-foreground" 
                    : "text-muted-foreground hover:bg-muted"}`}
              >
                <Gamepad2 className="h-4 w-4 transition-all group-hover:scale-110" />
                <span className="sr-only">Playground</span>
              </Link>
            </TooltipTrigger>
            <TooltipContent side="right" className="z-[100]">Playground</TooltipContent>
          </Tooltip>

          <Tooltip>
            <TooltipTrigger asChild>
              <Link
                to="/instances"
                className={`group flex h-9 w-9 shrink-0 items-center justify-center gap-2 rounded-full text-lg font-semibold md:h-8 md:w-8 md:text-base
                  ${location.pathname === "/instances" 
                    ? "bg-primary text-primary-foreground" 
                    : "text-muted-foreground hover:bg-muted"}`}
              >
                <Smartphone className="h-4 w-4 transition-all group-hover:scale-110" />
                <span className="sr-only">Instances</span>
              </Link>
            </TooltipTrigger>
            <TooltipContent side="right" className="z-[100]">Instances</TooltipContent>
          </Tooltip>

          <Tooltip>
            <TooltipTrigger asChild>
              <Link
                to="/settings"
                className={`group flex h-9 w-9 shrink-0 items-center justify-center gap-2 rounded-full text-lg font-semibold md:h-8 md:w-8 md:text-base
                  ${location.pathname === "/settings" 
                    ? "bg-primary text-primary-foreground" 
                    : "text-muted-foreground hover:bg-muted"}`}
              >
                <SettingsIcon className="h-4 w-4 transition-all group-hover:scale-110" />
                <span className="sr-only">Settings</span>
              </Link>
            </TooltipTrigger>
            <TooltipContent side="right" className="z-[100]">Settings</TooltipContent>
          </Tooltip>
        </TooltipProvider>
      </nav>
    </aside>
  );
} 